import React, { useState, useEffect } from "react";
import { Select, Switch, Row, Col, Collapse, Form } from "antd";
// style
import styles from "./form.module.css";
import { mypRoles } from "../../../../utils/mappingData";

const getMYPOptions = (isAdmin) => {
  return isAdmin ? mypRoles : mypRoles.filter((el) => el.id !== 1); // hide super admin role
};

const { Panel } = Collapse;
const { Option } = Select;

const MYPForm = ({ disabledState, getFieldValue, setFieldsValue, isAdmin }) => {
  const [solutionAccess, setSolutionAccess] = useState(
    getFieldValue("myp_solution_access"),
  );
  useEffect(() => {
    setSolutionAccess(getFieldValue("myp_solution_access"));
  }, [getFieldValue("myp_solution_access")]);

  const solutionAccessOnChange = (value) => {
    setSolutionAccess((prevState) => !prevState);
    setFieldsValue({ myp_solution_access: value });
  };
  return (
    <Collapse defaultActiveKey={["myp_1"]} expandIconPosition="end">
      <Panel header="myPerspective" key="myp_1">
        <div className="is_form_2_a">
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Solution Access</label>
              </Col>

              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Form.Item
                  style={{
                    borderBottom: "none",
                  }}
                  name="myp_solution_access"
                  valuePropName="checked"
                >
                  <Switch
                    disabled={
                      disabledState || (!isAdmin && !getFieldValue("myp_user"))
                    }
                    onChange={solutionAccessOnChange}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>MYP Role</label>
              </Col>

              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Form.Item
                  style={{
                    borderBottom: "none",
                  }}
                  name="myp_role"
                >
                  <Select
                    showSearch
                    optionFilterProp="children"
                    style={{ maxWidth: 300 }}
                    // notFoundContent={null}
                    placeholder="MYP Role"
                    disabled={
                      disabledState || !getFieldValue("myp_solution_access")
                    }
                  >
                    {getMYPOptions(isAdmin).map((d) => (
                      <Option key={d.id}>{d.name}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </div>
        </div>
      </Panel>
    </Collapse>
  );
};

export default MYPForm;
